import { type MissionsManager } from "@rescuetablet/missions-client";
import { MissionsContextProvider } from "@rescuetablet/missions-client/react";
import { useEffect, useState, type ReactNode } from "react";
import { useAuthenticated } from "../auth";
import GlobalLoading from "../components/GlobalLoading";
import { log } from "./config";
import { managerPromise } from "./connect";
import { useConnectMissionsStore } from "./store";

export function MissionsProvider({ children }: { children: ReactNode }) {
  const [manager, setManager] = useState<MissionsManager>();
  const [error, setError] = useState<unknown>();
  const { loadCount, missionApiKey } = useAuthenticated();

  useEffect(() => {
    log.info(`Initializing Missions Provider with load count ${loadCount}`);
    setManager(undefined);

    if (!missionApiKey) {
      return setError(new Error("No Mission API key in license."));
    }

    managerPromise
      .then(async (mgr) => {
        log.info(`Authorizing Missions Manager with load count ${loadCount}`);
        await mgr.authorize(missionApiKey);
        return mgr;
      })
      .then((mgr) => {
        log.info(`Missions Manager initialized with load count ${loadCount}`);
        setManager(mgr);
      })
      .catch((error) => {
        setManager(undefined);
        setError(error);
      });
  }, [missionApiKey, loadCount]);

  if (error) throw error;

  return manager ? (
    <MissionsContextProvider manager={manager}>
      <MissionsContent>{children}</MissionsContent>
    </MissionsContextProvider>
  ) : (
    <GlobalLoading />
  );
}

function MissionsContent({ children }: { children: ReactNode }) {
  useConnectMissionsStore();

  return <>{children}</>;
}
